(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2308],{

/***/ 99611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icons_EyeOutlined; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/EyeOutlined.js
// This icon file is generated automatically.
var EyeOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, "name": "eye", "theme": "outlined" };
/* harmony default export */ var asn_EyeOutlined = (EyeOutlined);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 2 modules
var AntdIcon = __webpack_require__(84089);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/EyeOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EyeOutlined_EyeOutlined = function EyeOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_EyeOutlined
  }));
};

EyeOutlined_EyeOutlined.displayName = 'EyeOutlined';
/* harmony default export */ var icons_EyeOutlined = (/*#__PURE__*/react.forwardRef(EyeOutlined_EyeOutlined));

/***/ }),

/***/ 15746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21584);

/* harmony default export */ __webpack_exports__["Z"] = (_grid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 79531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ input; }
});

// EXTERNAL MODULE: ./node_modules/antd/es/input/Input.js
var Input = __webpack_require__(77749);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/context.js + 1 modules
var context = __webpack_require__(59844);
;// CONCATENATED MODULE: ./node_modules/antd/es/input/Group.js





var Group = function Group(props) {
  return /*#__PURE__*/react.createElement(context/* ConfigConsumer */.C, null, function (_ref) {
    var _classNames;

    var getPrefixCls = _ref.getPrefixCls,
        direction = _ref.direction;
    var customizePrefixCls = props.prefixCls,
        _props$className = props.className,
        className = _props$className === void 0 ? '' : _props$className;
    var prefixCls = getPrefixCls('input-group', customizePrefixCls);
    var cls = classnames_default()(prefixCls, (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-lg"), props.size === 'large'), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-sm"), props.size === 'small'), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-compact"), props.compact), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), _classNames), className);
    return /*#__PURE__*/react.createElement("span", {
      className: cls,
      style: props.style,
      onMouseEnter: props.onMouseEnter,
      onMouseLeave: props.onMouseLeave,
      onFocus: props.onFocus,
      onBlur: props.onBlur
    }, props.children);
  });
};

/* harmony default export */ var input_Group = (Group);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/rc-util/es/ref.js
var es_ref = __webpack_require__(42550);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/SearchOutlined.js + 1 modules
var SearchOutlined = __webpack_require__(68795);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/SizeContext.js
var SizeContext = __webpack_require__(97647);
// EXTERNAL MODULE: ./node_modules/antd/es/_util/reactNode.js
var reactNode = __webpack_require__(96159);
;// CONCATENATED MODULE: ./node_modules/antd/es/input/Search.js



var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};










var Search = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _classNames;

  var customizePrefixCls = props.prefixCls,
      customizeInputPrefixCls = props.inputPrefixCls,
      className = props.className,
      customizeSize = props.size,
      suffix = props.suffix,
      _props$enterButton = props.enterButton,
      enterButton = _props$enterButton === void 0 ? false : _props$enterButton,
      addonAfter = props.addonAfter,
      loading = props.loading,
      disabled = props.disabled,
      customOnSearch = props.onSearch,
      customOnChange = props.onChange,
      restProps = __rest(props, ["prefixCls", "inputPrefixCls", "className", "size", "suffix", "enterButton", "addonAfter", "loading", "disabled", "onSearch", "onChange"]);

  var _React$useContext = react.useContext(context/* ConfigContext */.E_),
      getPrefixCls = _React$useContext.getPrefixCls,
      direction = _React$useContext.direction;

  var contextSize = react.useContext(SizeContext/* default */.Z);
  var size = customizeSize || contextSize;
  var inputRef = react.useRef(null);

  var onChange = function onChange(e) {
    if (e && e.target && e.type === 'click' && customOnSearch) {
      customOnSearch(e.target.value, e);
    }

    if (customOnChange) {
      customOnChange(e);
    }
  };

  var onMouseDown = function onMouseDown(e) {
    var _a;

    if (document.activeElement === ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input)) {
      e.preventDefault();
    }
  };

  var onSearch = function onSearch(e) {
    var _a;

    if (customOnSearch) {
      customOnSearch((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.input.value, e);
    }
  };

  var prefixCls = getPrefixCls('input-search', customizePrefixCls);
  var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
  var searchIcon = typeof enterButton === 'boolean' || typeof enterButton === 'undefined' ? /*#__PURE__*/react.createElement(SearchOutlined/* default */.Z, null) : null;
  var btnClassName = "".concat(prefixCls, "-button");
  var button;
  var enterButtonAsElement = enterButton || {};
  var isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;

  if (isAntdButton || enterButtonAsElement.type === 'button') {
    button = (0,reactNode/* cloneElement */.Tm)(enterButtonAsElement, (0,esm_extends/* default */.Z)({
      onMouseDown: onMouseDown,
      onClick: onSearch,
      key: 'enterButton'
    }, isAntdButton ? {
      className: btnClassName,
      size: size
    } : {}));
  } else {
    button = /*#__PURE__*/react.createElement(es_button/* default */.Z, {
      className: btnClassName,
      type: enterButton ? 'primary' : undefined,
      size: size,
      disabled: disabled,
      key: "enterButton",
      onMouseDown: onMouseDown,
      onClick: onSearch,
      loading: loading,
      icon: searchIcon
    }, enterButton);
  }

  if (addonAfter) {
    button = [button, (0,reactNode/* cloneElement */.Tm)(addonAfter, {
      key: 'addonAfter'
    })];
  }

  var cls = classnames_default()(prefixCls, (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-rtl"), direction === 'rtl'), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-").concat(size), !!size), (0,defineProperty/* default */.Z)(_classNames, "".concat(prefixCls, "-with-button"), !!enterButton), _classNames), className);
  return /*#__PURE__*/react.createElement(Input/* default */.ZP, (0,esm_extends/* default */.Z)({
    ref: (0,es_ref/* composeRef */.sQ)(inputRef, ref),
    onPressEnter: onSearch
  }, restProps, {
    size: size,
    prefixCls: inputPrefixCls,
    addonAfter: button,
    suffix: suffix,
    onChange: onChange,
    className: cls,
    disabled: disabled
  }));
});
Search.displayName = 'Search';
/* harmony default export */ var input_Search = (Search);
// EXTERNAL MODULE: ./node_modules/antd/es/input/TextArea.js + 3 modules
var TextArea = __webpack_require__(61705);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(97685);
// EXTERNAL MODULE: ./node_modules/rc-util/es/omit.js
var omit = __webpack_require__(98423);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/EyeOutlined.js + 1 modules
var EyeOutlined = __webpack_require__(99611);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/EyeInvisibleOutlined.js
// This icon file is generated automatically.
var EyeInvisibleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { "tag": "path", "attrs": { "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, "name": "eye-invisible", "theme": "outlined" };
/* harmony default export */ var asn_EyeInvisibleOutlined = (EyeInvisibleOutlined);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 2 modules
var AntdIcon = __webpack_require__(84089);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/EyeInvisibleOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var EyeInvisibleOutlined_EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_EyeInvisibleOutlined
  }));
};

EyeInvisibleOutlined_EyeInvisibleOutlined.displayName = 'EyeInvisibleOutlined';
/* harmony default export */ var icons_EyeInvisibleOutlined = (/*#__PURE__*/react.forwardRef(EyeInvisibleOutlined_EyeInvisibleOutlined));
;// CONCATENATED MODULE: ./node_modules/antd/es/input/Password.js




var Password_rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};









var ActionMap = {
  click: 'onClick',
  hover: 'onMouseOver'
};
var Password = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _useState = (0,react.useState)(false),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var onVisibleChange = function onVisibleChange() {
    var disabled = props.disabled;

    if (disabled) {
      return;
    }

    setVisible(!visible);
  };

  var getIcon = function getIcon(prefixCls) {
    var _iconProps;

    var action = props.action,
        _props$iconRender = props.iconRender,
        iconRender = _props$iconRender === void 0 ? function () {
      return null;
    } : _props$iconRender;
    var iconTrigger = ActionMap[action] || '';
    var icon = iconRender(visible);
    var iconProps = (_iconProps = {}, (0,defineProperty/* default */.Z)(_iconProps, iconTrigger, onVisibleChange), (0,defineProperty/* default */.Z)(_iconProps, "className", "".concat(prefixCls, "-icon")), (0,defineProperty/* default */.Z)(_iconProps, "key", 'passwordIcon'), (0,defineProperty/* default */.Z)(_iconProps, "onMouseDown", function onMouseDown(e) {
      // Prevent focused state lost
      // https://github.com/ant-design/ant-design/issues/15173
      e.preventDefault();
    }), (0,defineProperty/* default */.Z)(_iconProps, "onMouseUp", function onMouseUp(e) {
      // Prevent caret position change
      // https://github.com/ant-design/ant-design/issues/23524
      e.preventDefault();
    }), _iconProps);
    return /*#__PURE__*/react.cloneElement( /*#__PURE__*/react.isValidElement(icon) ? icon : /*#__PURE__*/react.createElement("span", null, icon), iconProps);
  };

  var renderPassword = function renderPassword(_ref) {
    var getPrefixCls = _ref.getPrefixCls;

    var className = props.className,
        customizePrefixCls = props.prefixCls,
        customizeInputPrefixCls = props.inputPrefixCls,
        size = props.size,
        visibilityToggle = props.visibilityToggle,
        restProps = Password_rest(props, ["className", "prefixCls", "inputPrefixCls", "size", "visibilityToggle"]);

    var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    var prefixCls = getPrefixCls('input-password', customizePrefixCls);
    var suffixIcon = visibilityToggle && getIcon(prefixCls);
    var inputClassName = classnames_default()(prefixCls, className, (0,defineProperty/* default */.Z)({}, "".concat(prefixCls, "-").concat(size), !!size));

    var omittedProps = (0,esm_extends/* default */.Z)((0,esm_extends/* default */.Z)({}, (0,omit/* default */.Z)(restProps, ['suffix', 'iconRender'])), {
      type: visible ? 'text' : 'password',
      className: inputClassName,
      prefixCls: inputPrefixCls,
      suffix: suffixIcon
    });

    if (size) {
      omittedProps.size = size;
    }

    return /*#__PURE__*/react.createElement(Input/* default */.ZP, (0,esm_extends/* default */.Z)({
      ref: ref
    }, omittedProps));
  };

  return /*#__PURE__*/react.createElement(context/* ConfigConsumer */.C, null, renderPassword);
});
Password.defaultProps = {
  action: 'click',
  visibilityToggle: true,
  iconRender: function iconRender(visible) {
    return visible ? /*#__PURE__*/react.createElement(EyeOutlined/* default */.Z, null) : /*#__PURE__*/react.createElement(icons_EyeInvisibleOutlined, null);
  }
};
Password.displayName = 'Password';
/* harmony default export */ var input_Password = (Password);
;// CONCATENATED MODULE: ./node_modules/antd/es/input/index.js





Input/* default.Group */.ZP.Group = input_Group;
Input/* default.Search */.ZP.Search = input_Search;
Input/* default.TextArea */.ZP.TextArea = TextArea/* default */.Z;
Input/* default.Password */.ZP.Password = input_Password;
/* harmony default export */ var input = (Input/* default */.ZP);

/***/ }),

/***/ 71230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _grid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3873);

/* harmony default export */ __webpack_exports__["Z"] = (_grid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 31690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Field */
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82580);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



const Field = (_a) => {
    var { fast, children } = _a, restProps = (0,tslib__WEBPACK_IMPORTED_MODULE_2__.__rest)(_a, ["fast", "children"]);
    if (fast) {
        return react__WEBPACK_IMPORTED_MODULE_1__.createElement(formik__WEBPACK_IMPORTED_MODULE_0__/* .FastField */ .Rt, Object.assign({}, restProps), children);
    }
    return react__WEBPACK_IMPORTED_MODULE_1__.createElement(formik__WEBPACK_IMPORTED_MODULE_0__/* .Field */ .gN, Object.assign({}, restProps), children);
};
/* harmony default export */ __webpack_exports__["Z"] = (Field);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 14271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Form; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82580);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8289);
/* harmony import */ var _form_item__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29553);




function Form(props) {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(formik__WEBPACK_IMPORTED_MODULE_1__/* .Field */ .gN, null, ({ form: { handleReset, handleSubmit } }) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, Object.assign({ onReset: handleReset, onFinish: handleSubmit }, props)))));
}
Form.Item = _form_item__WEBPACK_IMPORTED_MODULE_3__/* .FormItem */ .x;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Form)));
//# sourceMappingURL=form.js.map

/***/ }),

/***/ 96127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ TypedInput; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79531);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _field__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31690);




const Input = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
    var { name, validate, fast, onChange: $onChange, onBlur: $onBlur } = _a, restProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__rest)(_a, ["name", "validate", "fast", "onChange", "onBlur"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_field__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { name: name, validate: validate, fast: fast }, ({ field: { value, onChange, onBlur } }) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, Object.assign({ ref: ref, name: name, id: name, value: value, onChange: (event) => {
            onChange(event);
            $onChange && $onChange(event);
        }, onBlur: (event) => {
            onBlur(event);
            $onBlur && $onBlur(event);
        } }, restProps)))));
});
const TypedInput = Input;
TypedInput.Password = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
    var { name, validate, fast, onChange: $onChange, onBlur: $onBlur } = _a, restProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__rest)(_a, ["name", "validate", "fast", "onChange", "onBlur"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_field__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { name: name, validate: validate, fast: fast }, ({ field: { value, onChange, onBlur } }) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Password */ .Z.Password, Object.assign({ ref: ref, name: name, id: name, value: value, onChange: (event) => {
            onChange(event);
            $onChange && $onChange(event);
        }, onBlur: (event) => {
            onBlur(event);
            $onBlur && $onBlur(event);
        } }, restProps)))));
});
TypedInput.TextArea = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
    var { name, validate, fast, onChange: $onChange, onBlur: $onBlur } = _a, restProps = (0,tslib__WEBPACK_IMPORTED_MODULE_1__.__rest)(_a, ["name", "validate", "fast", "onChange", "onBlur"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_field__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { name: name, validate: validate, fast: fast }, ({ field: { value, onChange, onBlur } }) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"].TextArea */ .Z.TextArea, Object.assign({ ref: ref, name: name, id: name, value: value, onChange: (event) => {
            onChange(event);
            $onChange && $onChange(event);
        }, onBlur: (event) => {
            onBlur(event);
            $onBlur && $onBlur(event);
        } }, restProps)))));
});

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (TypedInput)));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 99924:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my/settings",
      function () {
        return __webpack_require__(6543);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VerifyCodeInput_hoc; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
;// CONCATENATED MODULE: ./packages/ui/src/components/verifyCodeInput/verifyCodeInput.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: 22px !important;\n  line-height: 22px !important;\n  padding: 0 4px !important;\n\n  span {\n    ",
        "\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n\n  &::before {\n    background-color: transparent;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var SendEmailButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z)(_templateObject(), mixins/* typography */.cp("p2"), colors.B1);

;// CONCATENATED MODULE: ./packages/ui/src/components/verifyCodeInput/verifyCodeInput.constant.js
var STATE_NORMAL = 0;
var STATE_SENDING = 1;
var STATE_LIMIT = 2;

// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 227 modules
var es = __webpack_require__(36486);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./packages/ui/src/components/countDown/countDown.styled.js
function countDown_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function countDown_styled_templateObject() {
    var data = countDown_styled_taggedTemplateLiteral([
        "\n  text-transform: none;\n"
    ]);
    countDown_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Text = styled_components_browser_esm/* default.span */.ZP.span(countDown_styled_templateObject());

;// CONCATENATED MODULE: ./packages/ui/src/components/countDown/CountDown.component.js





var defaultFormatter = function(ms) {
    return Math.round(ms / 1000);
};
var CountDown = function(param) {
    var total = param.total, counterRef = param.counterRef, onFinished = param.onFinished, _formatter = param.formatter, formatter = _formatter === void 0 ? defaultFormatter : _formatter, _interval = param.interval, interval = _interval === void 0 ? 1000 : _interval, children = param.children;
    var ref = (0,react.useState)(), time1 = ref[0], setTime = ref[1];
    var ref1 = (0,react.useState)(0), resetVersion = ref1[0], setResetVersion = ref1[1];
    if (counterRef && "current" in counterRef) {
        counterRef.current = {
            reset: function() {
                setResetVersion(resetVersion + 1);
            }
        };
    }
    (0,react.useEffect)(function() {
        setTime(total);
        var handle = setInterval(function() {
            setTime(function(time) {
                if (time >= interval) {
                    return time - interval;
                } else {
                    clearInterval(handle);
                    onFinished && onFinished();
                    return 0;
                }
            });
        }, interval);
        return function() {
            clearInterval(handle);
        };
    }, [
        total,
        interval,
        resetVersion,
        onFinished
    ]);
    return es.is(Function, children) ? children(formatter(time1)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
        children: formatter(time1)
    });
};
CountDown.propTypes = {
    total: (prop_types_default()).number.isRequired,
    counterRef: (prop_types_default()).object,
    onFinished: (prop_types_default()).func,
    formatter: (prop_types_default()).func,
    interval: (prop_types_default()).number,
    children: (prop_types_default()).func
};
/* harmony default export */ var CountDown_component = (CountDown);

;// CONCATENATED MODULE: ./packages/ui/src/components/verifyCodeInput/VerifyCodeInput.hoc.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var VerifyCodeSuffix = function(param) {
    var state = param.state, disabled = param.disabled, sendVerifyCodeBtnText = param.sendVerifyCodeBtnText, onClickSendButton = param.onClickSendButton, countDownTotal = param.countDownTotal, countDownFormatter = param.countDownFormatter, onCountDownFinished = param.onCountDownFinished;
    switch(state){
        case STATE_LIMIT:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SendEmailButton, {
                type: "link",
                disabled: true,
                size: "small",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CountDown_component, {
                    total: countDownTotal,
                    onFinished: onCountDownFinished,
                    formatter: countDownFormatter
                })
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SendEmailButton, {
                disabled: disabled,
                loading: state === STATE_SENDING,
                type: "link",
                onClick: onClickSendButton,
                size: "small",
                children: sendVerifyCodeBtnText
            });
    }
};
var withVerifyCode = function(Input) {
    return function(_param) {
        var sendVerifyCode = _param.sendVerifyCode, sendVerifyCodeBtnText = _param.sendVerifyCodeBtnText, limitSeconds = _param.limitSeconds, countDownFormatter = _param.countDownFormatter, _initialLimited = _param.initialLimited, initialLimited = _initialLimited === void 0 ? false : _initialLimited, buttonDisabled = _param.buttonDisabled, props = _objectWithoutProperties(_param, [
            "sendVerifyCode",
            "sendVerifyCodeBtnText",
            "limitSeconds",
            "countDownFormatter",
            "initialLimited",
            "buttonDisabled"
        ]);
        var ref = (0,react.useState)(initialLimited ? STATE_LIMIT : STATE_NORMAL), state = ref[0], setState = ref[1];
        var onCountDownFinished = (0,react.useCallback)(function() {
            return setState(STATE_NORMAL);
        }, []);
        var onClickSendButton = function() {
            if (state) return;
            var prevState = state;
            setState(STATE_SENDING);
            sendVerifyCode().then(function() {
                setState(STATE_LIMIT);
            }).catch(function() {
                setState(prevState);
            });
        };
        var suffixProps = {
            countDownFormatter: countDownFormatter,
            countDownTotal: limitSeconds,
            disabled: buttonDisabled || props.disabled,
            onClickSendButton: onClickSendButton,
            onCountDownFinished: onCountDownFinished,
            sendVerifyCodeBtnText: sendVerifyCodeBtnText,
            state: state
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, _objectSpread({}, props, {
            suffix: /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyCodeSuffix, _objectSpread({}, suffixProps))
        }));
    };
};
/* harmony default export */ var VerifyCodeInput_hoc = (withVerifyCode);


/***/ }),

/***/ 35703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Layout_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
;// CONCATENATED MODULE: ./src/pages/my/layout/layout.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  padding: 2rem 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border: 1px solid ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  font-weight: bold;\n  color: ",
        ";\n  padding: 0.8rem 1rem;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 1rem;\n\n  &,\n  .ant-form {\n    ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), mixins/* responsive */.jW());
var Main = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), colors.T2);
var Title = styled_components_browser_esm/* default.h1 */.ZP.h1(_templateObject2(), mixins/* typography */.cp("p1"), mixins/* reset */.mc(), colors.F1, colors.T2);
var Content = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3(), mixins/* typography */.cp("p2"));

// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/antd/es/badge/index.js + 4 modules
var badge = __webpack_require__(63922);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/pages/my/layout/menu/menu.styled.js
function menu_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function menu_styled_templateObject() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  background: ",
        ";\n  list-style: none;\n  border: 1px solid ",
        ";\n"
    ]);
    menu_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function menu_styled_templateObject1() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n      cursor: default;\n      border-left: 3px solid ",
        ";\n      background: ",
        " !important;\n    "
    ]);
    menu_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function menu_styled_templateObject2() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  justify-content: space-between;\n  padding: 0 1rem;\n  cursor: pointer;\n\n  &:hover {\n    background: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    menu_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var menu_styled_Container = styled_components_browser_esm/* default.ul */.ZP.ul(menu_styled_templateObject(), mixins/* reset */.mc(), mixins/* typography */.cp("p2"), colors.M1, colors.T2);
var Item = styled_components_browser_esm/* default.li */.ZP.li(menu_styled_templateObject2(), mixins/* flexVerticalCenter */.VL(), mixins/* verticalLineMiddle */.XK("2.5rem"), colors.M2, function(props) {
    return props.isActive && (0,styled_components_browser_esm/* css */.iv)(menu_styled_templateObject1(), colors.B1, colors.M1);
});

// EXTERNAL MODULE: ./src/context/index.js + 3 modules
var context = __webpack_require__(62675);
// EXTERNAL MODULE: ./src/utils/index.js + 2 modules
var utils = __webpack_require__(49714);
;// CONCATENATED MODULE: ./src/pages/my/layout/menu/Menu.component.js








var Menu = function() {
    var router = (0,next_router.useRouter)();
    var isLoggedIn = (0,react.useContext)(context/* AuthContext */.Vo).isLoggedIn;
    var ref = (0,dist/* default */.ZP)(isLoggedIn && "operation.fetchRedDots"), redDotsResp = ref.data;
    var redDots = utils/* redDots.transformRespToMap */.a_.transformRespToMap(redDotsResp);
    var asPath = router.asPath;
    var genPath = function(path) {
        return "/my/".concat(path);
    };
    var profilePath = genPath("profile");
    var companyPath = genPath("company");
    var settingsPath = genPath("settings");
    var onClick = function(path) {
        return function() {
            router.push(path);
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(menu_styled_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                isActive: asPath === profilePath,
                onClick: onClick(profilePath),
                children: "\u4E2A\u4EBA\u4FE1\u606F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                isActive: asPath === companyPath,
                onClick: onClick(companyPath),
                children: [
                    "\u516C\u53F8\u4FE1\u606F ",
                    redDots.companyInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {
                        count: "+20\u79EF\u5206"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                isActive: asPath === settingsPath,
                onClick: onClick(settingsPath),
                children: "\u8D26\u53F7\u8BBE\u7F6E"
            })
        ]
    });
};
/* harmony default export */ var Menu_component = (Menu);

;// CONCATENATED MODULE: ./src/pages/my/layout/menu/index.js


// EXTERNAL MODULE: ./src/layouts/index.js + 12 modules
var layouts = __webpack_require__(70230);
;// CONCATENATED MODULE: ./src/pages/my/layout/Layout.component.js







var Layout = function(param) {
    var children = param.children, title = param.title;
    var setIsAuthRequired = (0,react.useContext)(context/* AuthContext */.Vo).setIsAuthRequired;
    (0,react.useEffect)(function() {
        setIsAuthRequired(true);
        return function() {
            return setIsAuthRequired(false);
        };
    }, [
        setIsAuthRequired
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* CoreLayout */.N, {
            hasMargin: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                    gutter: [
                        32,
                        32
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            xs: 24,
                            sm: 8,
                            md: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_component, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                            xs: 24,
                            sm: 16,
                            md: 18,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Main, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                                        children: children
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Layout_component = (Layout);

;// CONCATENATED MODULE: ./src/pages/my/layout/index.js



/***/ }),

/***/ 6543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./src/context/index.js + 3 modules
var context = __webpack_require__(62675);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 14 modules
var modal = __webpack_require__(20228);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 1 modules
var message = __webpack_require__(12461);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/ExclamationCircleOutlined.js + 1 modules
var ExclamationCircleOutlined = __webpack_require__(11475);
// EXTERNAL MODULE: ./packages/datasource/src/api/social/index.js
var social = __webpack_require__(62253);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
;// CONCATENATED MODULE: ./src/pages/my/settings/content/github.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgGithub = function SvgGithub(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0 1 12 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z"
  })));
};
/* harmony default export */ var github = (SvgGithub);
;// CONCATENATED MODULE: ./src/pages/my/settings/content/wechat.svg
var wechat_path;
function wechat_extends() { wechat_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return wechat_extends.apply(this, arguments); }

var SvgWechat = function SvgWechat(props) {
  return /*#__PURE__*/react.createElement("svg", wechat_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 24 24"
  }, props), wechat_path || (wechat_path = /*#__PURE__*/react.createElement("path", {
    d: "M12 0C5.374 0 0 5.372 0 12c0 6.627 5.374 12 12 12 6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12zm5.543 16.389c.889-.644 1.457-1.597 1.457-2.656 0-1.94-1.888-3.514-4.217-3.514-2.329 0-4.217 1.574-4.217 3.514 0 1.941 1.888 3.514 4.217 3.514a4.99 4.99 0 0 0 1.377-.192l.124-.019c.081 0 .154.025.224.065l.923.533.081.026a.14.14 0 0 0 .14-.14l-.022-.103-.19-.709-.015-.09c0-.094.047-.178.118-.229zM10.06 6.34C7.266 6.34 5 8.228 5 10.557c0 1.27.682 2.414 1.748 3.187a.336.336 0 0 1 .142.275l-.018.107-.228.851-.027.123a.17.17 0 0 0 .169.169l.097-.032 1.108-.639a.532.532 0 0 1 .269-.078l.149.022a5.965 5.965 0 0 0 1.651.231l.278-.006a3.248 3.248 0 0 1-.17-1.034c0-2.123 2.066-3.845 4.615-3.845l.275.007C14.677 7.88 12.585 6.34 10.06 6.34zm3.317 6.831a.562.562 0 1 1 .001-1.125.562.562 0 0 1-.001 1.125zm2.812 0a.562.562 0 1 1 0-1.124.562.562 0 0 1 0 1.124zM8.374 9.882a.675.675 0 1 1 0-1.35.675.675 0 0 1 0 1.35zm3.373 0a.675.675 0 1 1 0-1.35.675.675 0 0 1 0 1.35z"
  })));
};
/* harmony default export */ var wechat = (SvgWechat);
;// CONCATENATED MODULE: ./src/pages/my/settings/content/content.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 12px !important;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  span {\n    cursor: pointer;\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 1rem;\n\n  .ant-btn,\n  ",
        " {\n    ",
        ";\n    margin-right: 2rem;\n\n    &:last-child {\n      margin-right: 0;\n    }\n\n    svg {\n      ",
        ";\n      margin-right: 6px;\n    }\n  }\n\n  .ant-btn {\n    padding: 0;\n    text-transform: none;\n    height: initial;\n    line-height: 1;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  fill: #000;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  fill: #04d468;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var Desc = styled_components_browser_esm/* default.p */.ZP.p(_templateObject());
var Account = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), colors.B1);
var SocialAccounts = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2(), Account, mixins/* flexVerticalCenter */.VL("inline"), mixins/* size */.dp("18px"));
var GithubIcon = (0,styled_components_browser_esm/* default */.ZP)(github)(_templateObject3());
var WeChatIcon = (0,styled_components_browser_esm/* default */.ZP)(wechat)(_templateObject4());

;// CONCATENATED MODULE: ./src/pages/my/settings/content/box/box.styled.js
function box_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function box_styled_templateObject() {
    var data = box_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  border: 1px solid ",
        ";\n  padding: 1rem;\n  margin-bottom: 1rem;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  h2,\n  p {\n    ",
        ";\n  }\n\n  h2 {\n    ",
        ";\n    font-weight: bold;\n  }\n\n  p {\n    margin-top: 0.5rem;\n    ",
        ";\n  }\n\n  .extra {\n    ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    box_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function box_styled_templateObject1() {
    var data = box_styled_taggedTemplateLiteral([
        "\n  flex: 1;\n"
    ]);
    box_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div */.ZP.div(box_styled_templateObject(), mixins/* flexVerticalCenter */.VL(), colors.T2, mixins/* reset */.mc(), mixins/* typography */.cp("p1"), mixins/* typography */.cp("p2"), mixins/* typography */.cp("p2"), colors.C4);
var Content = styled_components_browser_esm/* default.div */.ZP.div(box_styled_templateObject1());

;// CONCATENATED MODULE: ./src/pages/my/settings/content/box/Box.component.js




var Box = function(param) {
    var title = param.title, text = param.text, extra = param.extra, children = param.children, _settingsLabel = param.settingsLabel, settingsLabel = _settingsLabel === void 0 ? "\u8BBE\u7F6E" : _settingsLabel, _onSettingsClick = param.onSettingsClick, onSettingsClick = _onSettingsClick === void 0 ? function() {} : _onSettingsClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: children ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
            children: children
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            children: [
                                text,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: extra
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                    type: "link",
                    onClick: onSettingsClick,
                    children: settingsLabel
                })
            ]
        })
    });
};
/* harmony default export */ var Box_component = (Box);

;// CONCATENATED MODULE: ./src/pages/my/settings/content/box/index.js


// EXTERNAL MODULE: ./node_modules/formik-antd/es/form/form.js
var form_form = __webpack_require__(14271);
// EXTERNAL MODULE: ./node_modules/formik-antd/es/form-item/index.js
var form_item = __webpack_require__(29553);
// EXTERNAL MODULE: ./node_modules/formik-antd/es/input/index.js
var input = __webpack_require__(96127);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./packages/datasource/src/api/account/index.js
var account = __webpack_require__(41151);
;// CONCATENATED MODULE: ./src/pages/my/settings/content/modals/modal.styled.js
function modal_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function modal_styled_templateObject() {
    var data = modal_styled_taggedTemplateLiteral([
        "\n  .ant-form {\n    .ant-form-item,\n    .ant-input-affix-wrapper {\n      margin-bottom: 1rem;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n  }\n"
    ]);
    modal_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var modal_styled_Container = styled_components_browser_esm/* default.div */.ZP.div(modal_styled_templateObject());

;// CONCATENATED MODULE: ./src/pages/my/settings/content/modals/Modal.component.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




// See: https://github.com/ant-design/ant-design/issues/9380#issuecomment-581027250
// Please note, the official useForm solution doesn't work if importing Form from
// formik-antd. It's more like an issue of formik-antd but I haven't dived into it.
var formId = "my-settings-form";
var Modal = function(_param) /*#__PURE__*/ {
    var children = _param.children, extendedOkButtonProps = _param.extendedOkButtonProps, props = _objectWithoutProperties(_param, [
        "children",
        "extendedOkButtonProps"
    ]);
    return (0,jsx_runtime.jsx)(modal/* default */.Z, _objectSpread({
        cancelText: "\u53D6\u6D88",
        destroyOnClose: true,
        okButtonProps: _objectSpread({
            form: formId,
            htmlType: "submit"
        }, extendedOkButtonProps),
        okText: "\u786E\u5B9A",
        onCancel: props.onClose,
        width: 480
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_styled_Container, {
            children: children
        })
    }));
};
/* harmony default export */ var Modal_component = (Modal);

// EXTERNAL MODULE: ./packages/common/src/index.js + 3 modules
var src = __webpack_require__(94174);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./src/pages/my/settings/content/modals/modal.fields.js
// Common field definitions shared among forms

var code = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _name = ref.name, name = _name === void 0 ? "code" : _name;
    return {
        name: name,
        placeholder: "6\u4F4D\u9A8C\u8BC1\u7801",
        validator: es/* string */.Z_().length(6, function(param) {
            var length = param.length;
            return "\u8BF7\u8F93\u5165".concat(length, "\u4F4D\u9A8C\u8BC1\u7801");
        }).required("\u9A8C\u8BC1\u7801\u4E0D\u53EF\u4E3A\u7A7A"),
        initialValue: "",
        sendVerifyCodeBtnText: "\u53D1\u9001\u9A8C\u8BC1\u7801",
        limitSeconds: 60000,
        countDownFormatter: function(ms) {
            return "".concat(Math.round(ms / 1000), "s");
        }
    };
};
var newPassword = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _name = ref.name, name = _name === void 0 ? "new_password" : _name, _placeholder = ref.placeholder, placeholder = _placeholder === void 0 ? "\u8BF7\u8F93\u5165\u65B0\u5BC6\u7801" : _placeholder;
    return {
        name: name,
        placeholder: placeholder,
        validator: es/* string */.Z_().required("\u5BC6\u7801\u4E0D\u53EF\u4E3A\u7A7A").min(8, "\u5BC6\u7801\u6700\u5C11\u4E3A8\u4E2A\u5B57\u7B26"),
        initialValue: "",
        type: "password"
    };
};
var confirmPassword = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _name = ref.name, name = _name === void 0 ? "confirm_password" : _name, _placeholder = ref.placeholder, placeholder = _placeholder === void 0 ? "\u8BF7\u518D\u6B21\u8F93\u5165\u65B0\u5BC6\u7801" : _placeholder;
    return {
        name: name,
        placeholder: placeholder,
        validator: es/* string */.Z_().required("\u5BC6\u7801\u4E0D\u53EF\u4E3A\u7A7A").oneOf([
            es/* ref */.iH("new_password")
        ], "\u4E24\u6B21\u5BC6\u7801\u8F93\u5165\u4E0D\u76F8\u540C"),
        initialValue: "",
        type: "password"
    };
};

;// CONCATENATED MODULE: ./src/pages/my/settings/content/modals/setPasswordModal/setPasswordModal.fields.js


var _form = src/* utils.form */.P6.cr, buildInitialValues = _form.buildInitialValues, buildSchema = _form.buildSchema;
var fields = {
    newPassword: newPassword(),
    confirmPassword: confirmPassword()
};
var initialValues = buildInitialValues(fields);
var schema = buildSchema(fields);

// EXTERNAL MODULE: ./src/utils/index.js + 2 modules
var utils = __webpack_require__(49714);
;// CONCATENATED MODULE: ./src/pages/my/settings/content/modals/setPasswordModal/SetPasswordModal.component.js
function SetPasswordModal_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SetPasswordModal_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SetPasswordModal_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SetPasswordModal_component_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = SetPasswordModal_component_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function SetPasswordModal_component_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var SetPasswordModal_component_Modal = function(_param) {
    var onSuccess = _param.onSuccess, props = SetPasswordModal_component_objectWithoutProperties(_param, [
        "onSuccess"
    ]);
    var ref = (0,react.useState)(false), isSubmitting = ref[0], setIsSubmitting = ref[1];
    var onClose = props.onClose;
    var newPassword = fields.newPassword, confirmPassword = fields.confirmPassword;
    var onSubmit = utils/* form.wrapFormikSubmitFunction */.cr.wrapFormikSubmitFunction(function(values) {
        setIsSubmitting(true);
        return account.setPassword(SetPasswordModal_component_objectSpread({}, values)).then(function() {
            onClose();
            onSuccess();
        }).finally(function() {
            setIsSubmitting(false);
        });
    });
    var modalProps = SetPasswordModal_component_objectSpread({}, props, {
        title: "\u8BBE\u7F6E\u5BC6\u7801",
        extendedOkButtonProps: {
            loading: isSubmitting
        }
    });
    var formikProps = {
        initialValues: initialValues,
        onSubmit: onSubmit,
        validationSchema: schema
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_component, SetPasswordModal_component_objectSpread({}, modalProps, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, SetPasswordModal_component_objectSpread({}, formikProps, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_form/* Form */.l, {
                id: formId,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_item/* FormItem */.x, {
                        name: newPassword.name,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, SetPasswordModal_component_objectSpread({}, newPassword))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_item/* FormItem */.x, {
                        name: confirmPassword.name,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, SetPasswordModal_component_objectSpread({}, confirmPassword))
                    })
                ]
            })
        }))
    }));
};
/* harmony default export */ var SetPasswordModal_component = (SetPasswordModal_component_Modal);

;// CONCATENATED MODULE: ./src/pages/my/settings/content/modals/setPasswordModal/index.js


// EXTERNAL MODULE: ./packages/ui/src/components/verifyCodeInput/VerifyCodeInput.hoc.js + 4 modules
var VerifyCodeInput_hoc = __webpack_require__(98537);
;// CONCATENATED MODULE: ./src/pages/my/settings/content/modals/updateEmailModal/updateEmailModal.fields.js



var updateEmailModal_fields_form = src/* utils.form */.P6.cr, updateEmailModal_fields_buildInitialValues = updateEmailModal_fields_form.buildInitialValues, updateEmailModal_fields_buildSchema = updateEmailModal_fields_form.buildSchema;
var updateEmailModal_fields_fields = {
    email: {
        name: "email",
        placeholder: "\u8BF7\u8F93\u5165\u90AE\u7BB1",
        validator: es/* string */.Z_().email("\u8BF7\u8F93\u5165\u6709\u6548\u7684\u90AE\u7BB1").required("\u90AE\u7BB1\u4E0D\u53EF\u4E3A\u7A7A"),
        initialValues: ""
    },
    code: code()
};
var updateEmailModal_fields_initialValues = updateEmailModal_fields_buildInitialValues(updateEmailModal_fields_fields);
var updateEmailModal_fields_schema = updateEmailModal_fields_buildSchema(updateEmailModal_fields_fields);

;// CONCATENATED MODULE: ./src/pages/my/settings/content/modals/updateEmailModal/UpdateEmailModal.component.js
function UpdateEmailModal_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function UpdateEmailModal_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            UpdateEmailModal_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function UpdateEmailModal_component_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = UpdateEmailModal_component_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function UpdateEmailModal_component_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var VerifyCodeInput = (0,VerifyCodeInput_hoc/* default */.Z)(input/* Input */.I);
var UpdateEmailModal_component_Modal = function(_param) {
    var verified = _param.verified, mutate = _param.mutate, props = UpdateEmailModal_component_objectWithoutProperties(_param, [
        "verified",
        "mutate"
    ]);
    var ref = (0,react.useState)(false), isSubmitting = ref[0], setIsSubmitting = ref[1];
    var onClose = props.onClose;
    var email1 = updateEmailModal_fields_fields.email, code = updateEmailModal_fields_fields.code;
    var emailName = email1.name;
    var onSubmit = utils/* form.wrapFormikSubmitFunction */.cr.wrapFormikSubmitFunction(function(values) {
        setIsSubmitting(true);
        return account.setEmail(UpdateEmailModal_component_objectSpread({}, values)).then(function() {
            message/* default.success */.ZP.success("\u90AE\u7BB1\u66F4\u65B0\u6210\u529F");
            mutate();
            onClose();
        }).finally(function() {
            setIsSubmitting(false);
        });
    });
    var modalProps = UpdateEmailModal_component_objectSpread({}, props, {
        title: verified ? "\u66F4\u6539\u90AE\u7BB1" : "\u9A8C\u8BC1\u90AE\u7BB1",
        extendedOkButtonProps: {
            loading: isSubmitting
        }
    });
    var formikProps = {
        initialValues: updateEmailModal_fields_initialValues,
        onSubmit: onSubmit,
        validationSchema: updateEmailModal_fields_schema
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_component, UpdateEmailModal_component_objectSpread({}, modalProps, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, UpdateEmailModal_component_objectSpread({}, formikProps, {
            children: function(param) {
                var values = param.values, errors = param.errors, setErrors = param.setErrors, setTouched = param.setTouched;
                var sendVerifyCode = utils/* form.wrapFormikSubmitFunction */.cr.wrapFormikSubmitFunction(function() {
                    return account.sendEmailCode({
                        email: values[emailName]
                    });
                });
                var codeInputProps = UpdateEmailModal_component_objectSpread({}, code, {
                    sendVerifyCode: function(email) {
                        return sendVerifyCode(email, {
                            setErrors: setErrors,
                            setTouched: setTouched
                        });
                    },
                    buttonDisabled: errors[emailName] || !values[emailName]
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_form/* Form */.l, {
                    id: formId,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(form_item/* FormItem */.x, {
                            name: emailName,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, UpdateEmailModal_component_objectSpread({}, email1))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(form_item/* FormItem */.x, {
                            name: code.name,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyCodeInput, UpdateEmailModal_component_objectSpread({}, codeInputProps))
                        })
                    ]
                });
            }
        }))
    }));
};
/* harmony default export */ var UpdateEmailModal_component = (UpdateEmailModal_component_Modal);

;// CONCATENATED MODULE: ./src/pages/my/settings/content/modals/updateEmailModal/index.js


;// CONCATENATED MODULE: ./src/pages/my/settings/content/modals/updatePasswordModal/updatePasswordModal.fields.js
function updatePasswordModal_fields_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function updatePasswordModal_fields_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            updatePasswordModal_fields_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var updatePasswordModal_fields_form = src/* utils.form */.P6.cr, updatePasswordModal_fields_buildInitialValues = updatePasswordModal_fields_form.buildInitialValues, updatePasswordModal_fields_buildSchema = updatePasswordModal_fields_form.buildSchema;
var updatePasswordModal_fields_fields = {
    oldPassword: updatePasswordModal_fields_objectSpread({}, newPassword(), {
        name: "old_password",
        placeholder: "\u8BF7\u8F93\u5165\u5F53\u524D\u5BC6\u7801",
        validator: es/* string */.Z_().required("\u5BC6\u7801\u4E0D\u53EF\u4E3A\u7A7A")
    }),
    newPassword: newPassword(),
    confirmPassword: confirmPassword()
};
var updatePasswordModal_fields_initialValues = updatePasswordModal_fields_buildInitialValues(updatePasswordModal_fields_fields);
var updatePasswordModal_fields_schema = updatePasswordModal_fields_buildSchema(updatePasswordModal_fields_fields);

;// CONCATENATED MODULE: ./src/pages/my/settings/content/modals/updatePasswordModal/UpdatePasswordModal.component.js
function UpdatePasswordModal_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function UpdatePasswordModal_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            UpdatePasswordModal_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function UpdatePasswordModal_component_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = UpdatePasswordModal_component_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function UpdatePasswordModal_component_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var UpdatePasswordModal_component_Modal = function(_param) {
    var onSuccess = _param.onSuccess, props = UpdatePasswordModal_component_objectWithoutProperties(_param, [
        "onSuccess"
    ]);
    var ref = (0,react.useState)(false), isSubmitting = ref[0], setIsSubmitting = ref[1];
    var onClose = props.onClose;
    var oldPassword = updatePasswordModal_fields_fields.oldPassword, newPassword = updatePasswordModal_fields_fields.newPassword, confirmPassword = updatePasswordModal_fields_fields.confirmPassword;
    var onSubmit = utils/* form.wrapFormikSubmitFunction */.cr.wrapFormikSubmitFunction(function(values) {
        setIsSubmitting(true);
        return account.resetPassword(UpdatePasswordModal_component_objectSpread({}, values)).then(function() {
            onClose();
            onSuccess();
        }).finally(function() {
            setIsSubmitting(false);
        });
    });
    var modalProps = UpdatePasswordModal_component_objectSpread({}, props, {
        title: "\u66F4\u6539\u5BC6\u7801",
        extendedOkButtonProps: {
            loading: isSubmitting
        }
    });
    var formikProps = {
        initialValues: updatePasswordModal_fields_initialValues,
        onSubmit: onSubmit,
        validationSchema: updatePasswordModal_fields_schema
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_component, UpdatePasswordModal_component_objectSpread({}, modalProps, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, UpdatePasswordModal_component_objectSpread({}, formikProps, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_form/* Form */.l, {
                id: formId,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_item/* FormItem */.x, {
                        name: oldPassword.name,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, UpdatePasswordModal_component_objectSpread({}, oldPassword))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_item/* FormItem */.x, {
                        name: newPassword.name,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, UpdatePasswordModal_component_objectSpread({}, newPassword))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(form_item/* FormItem */.x, {
                        name: confirmPassword.name,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Input */.I, UpdatePasswordModal_component_objectSpread({}, confirmPassword))
                    })
                ]
            })
        }))
    }));
};
/* harmony default export */ var UpdatePasswordModal_component = (UpdatePasswordModal_component_Modal);

;// CONCATENATED MODULE: ./src/pages/my/settings/content/modals/updatePasswordModal/index.js


;// CONCATENATED MODULE: ./src/pages/my/settings/content/modals/updatePhoneModal/updatePhoneModal.styled.js
function updatePhoneModal_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function updatePhoneModal_styled_templateObject() {
    var data = updatePhoneModal_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n\n  .ant-input-prefix {\n    color: ",
        ";\n    height: 18px;\n    padding-right: 0.5rem;\n    margin-right: 0.5rem;\n    border-right: 1px solid ",
        ";\n  }\n"
    ]);
    updatePhoneModal_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var PhoneInput = (0,styled_components_browser_esm/* default */.ZP)(input/* Input */.I)(updatePhoneModal_styled_templateObject(), mixins/* flexVerticalCenter */.VL(), colors.F2, colors.C2);

;// CONCATENATED MODULE: ./src/pages/my/settings/content/modals/updatePhoneModal/updatePhoneModal.fields.js



var updatePhoneModal_fields_form = src/* utils.form */.P6.cr, updatePhoneModal_fields_buildInitialValues = updatePhoneModal_fields_form.buildInitialValues, updatePhoneModal_fields_buildSchema = updatePhoneModal_fields_form.buildSchema;
var updatePhoneModal_fields_fields = {
    phone: {
        name: "phone",
        placeholder: "\u8BF7\u8F93\u5165\u65B0\u624B\u673A\u53F7\u7801",
        validator: es/* string */.Z_().length(11, function(param) {
            var length = param.length;
            return "\u624B\u673A\u53F7\u957F\u5EA6\u5FC5\u987B\u4E3A".concat(length, "\u4F4D");
        }).required("\u624B\u673A\u53F7\u4E0D\u53EF\u4E3A\u7A7A"),
        initialValue: ""
    },
    code: code()
};
var updatePhoneModal_fields_initialValues = updatePhoneModal_fields_buildInitialValues(updatePhoneModal_fields_fields);
var updatePhoneModal_fields_schema = updatePhoneModal_fields_buildSchema(updatePhoneModal_fields_fields);

;// CONCATENATED MODULE: ./src/pages/my/settings/content/modals/updatePhoneModal/UpdatePhoneModal.component.js
function UpdatePhoneModal_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function UpdatePhoneModal_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            UpdatePhoneModal_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function UpdatePhoneModal_component_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = UpdatePhoneModal_component_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function UpdatePhoneModal_component_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}











var UpdatePhoneModal_component_VerifyCodeInput = (0,VerifyCodeInput_hoc/* default */.Z)(input/* Input */.I);
var UpdatePhoneModal_component_Modal = function(_param) {
    var mutate = _param.mutate, props = UpdatePhoneModal_component_objectWithoutProperties(_param, [
        "mutate"
    ]);
    var ref = (0,react.useState)(false), isSubmitting = ref[0], setIsSubmitting = ref[1];
    var onClose = props.onClose;
    var phone1 = updatePhoneModal_fields_fields.phone, code = updatePhoneModal_fields_fields.code;
    var phoneName = phone1.name;
    var onSubmit = utils/* form.wrapFormikSubmitFunction */.cr.wrapFormikSubmitFunction(function(values) {
        setIsSubmitting(true);
        return account.setPhone(UpdatePhoneModal_component_objectSpread({}, values)).then(function() {
            message/* default.success */.ZP.success("\u624B\u673A\u53F7\u7801\u66F4\u65B0\u6210\u529F");
            mutate();
            onClose();
        }).finally(function() {
            setIsSubmitting(false);
        });
    });
    var modalProps = UpdatePhoneModal_component_objectSpread({}, props, {
        title: "\u66F4\u6539\u624B\u673A\u53F7\u7801",
        extendedOkButtonProps: {
            loading: isSubmitting
        }
    });
    var formikProps = {
        initialValues: updatePhoneModal_fields_initialValues,
        onSubmit: onSubmit,
        validationSchema: updatePhoneModal_fields_schema
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_component, UpdatePhoneModal_component_objectSpread({}, modalProps, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, UpdatePhoneModal_component_objectSpread({}, formikProps, {
            children: function(param) {
                var values = param.values, errors = param.errors, setErrors = param.setErrors, setTouched = param.setTouched;
                var sendVerifyCode = utils/* form.wrapFormikSubmitFunction */.cr.wrapFormikSubmitFunction(function() {
                    return account.sendPhoneCode({
                        phone: values[phoneName]
                    });
                });
                var codeInputProps = UpdatePhoneModal_component_objectSpread({}, code, {
                    sendVerifyCode: function(phone) {
                        return sendVerifyCode(phone, {
                            setErrors: setErrors,
                            setTouched: setTouched
                        });
                    },
                    buttonDisabled: errors[phoneName] || !values[phoneName]
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(form_form/* Form */.l, {
                    id: formId,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(form_item/* FormItem */.x, {
                            name: phoneName,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneInput, UpdatePhoneModal_component_objectSpread({
                                prefix: "+86"
                            }, phone1))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(form_item/* FormItem */.x, {
                            name: code.name,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdatePhoneModal_component_VerifyCodeInput, UpdatePhoneModal_component_objectSpread({}, codeInputProps))
                        })
                    ]
                });
            }
        }))
    }));
};
/* harmony default export */ var UpdatePhoneModal_component = (UpdatePhoneModal_component_Modal);

;// CONCATENATED MODULE: ./src/pages/my/settings/content/modals/updatePhoneModal/index.js


;// CONCATENATED MODULE: ./src/pages/my/settings/content/modals/index.js




var MODALS = {
    SET_PASSWORD: Symbol("SET_PASSWORD"),
    UPDATE_EMAIL: Symbol("UPDATE_EMAIL"),
    UPDATE_PASSWORD: Symbol("UPDATE_PASSWORD"),
    UPDATE_PHONE: Symbol("UPDATE_PHONE")
};

;// CONCATENATED MODULE: ./src/pages/my/settings/content/Content.component.js
function Content_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Content_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Content_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}










var Content_component_Content = function() {
    var ref = (0,react.useState)(), visibleModal = ref[0], setVisibleModal = ref[1];
    var ref1 = (0,dist/* default */.ZP)("account.settings"), settingsResp = ref1.data, error = ref1.error, mutate = ref1.mutate;
    var login = (0,react.useContext)(context/* AuthContext */.Vo).login;
    var isLoading = !error && !settingsResp;
    if (isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
        active: true
    });
    var data = settingsResp.data;
    var github = data.associated_accounts.github, hasPassword = data.has_password;
    var openModal = function(type) {
        return function() {
            return setVisibleModal(type);
        };
    };
    var onModalClose = function() {
        setVisibleModal();
    };
    var genModalProps = function(modal) {
        return {
            mutate: mutate,
            onClose: onModalClose,
            visible: visibleModal === modal
        };
    };
    var bind = function(provider) {
        return function() {
            social.login({
                provider: provider,
                redirect_to: window.location.href
            });
            var location = window.location;
            location.href = "".concat("https://pingkai.cn/accounts", "/social/login/").concat(provider, "?redirect_to=").concat(encodeURIComponent(location.href));
        };
    };
    var reLogin = function() {
        window.confirm("\u60A8\u5DF2\u66F4\u65B0\u5BC6\u7801\uFF0C\u8BF7\u91CD\u65B0\u767B\u5F55\u3002");
        login();
    };
    var unbind = function(provider) {
        return function() {
            modal/* default.confirm */.Z.confirm({
                title: "\u786E\u5B9A\u89E3\u7ED1 GitHub \u8D26\u53F7\u5417\uFF1F",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExclamationCircleOutlined/* default */.Z, {}),
                content: "\u89E3\u9664\u7ED1\u5B9A\u540E\uFF0C\u60A8\u65E0\u6CD5\u518D\u901A\u8FC7 GitHub \u8D26\u53F7\u5FEB\u901F\u767B\u5F55",
                okText: "\u786E\u8BA4",
                cancelText: "\u53D6\u6D88",
                onOk: function() {
                    social.disconnect(provider).then(function() {
                        message/* default.success */.ZP.success("\u89E3\u7ED1\u6210\u529F");
                        mutate(Content_component_objectSpread({}, settingsResp, {
                            data: Content_component_objectSpread({}, data, {
                                associated_accounts: Content_component_defineProperty({}, provider, null)
                            })
                        }), false);
                    });
                }
            });
        };
    };
    var _phone, _email;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_component, {
                title: "\u624B\u673A\u53F7\u7801",
                text: (_phone = data.phone) !== null && _phone !== void 0 ? _phone : "\u672A\u8BBE\u7F6E",
                onSettingsClick: openModal(MODALS.UPDATE_PHONE)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_component, {
                title: "\u90AE\u7BB1",
                text: (_email = data.email) !== null && _email !== void 0 ? _email : "\u672A\u8BBE\u7F6E",
                extra: data.email && !data.email_verified ? "\uFF08\u672A\u9A8C\u8BC1\uFF0C\u9A8C\u8BC1\u540E\u53EF\u901A\u8FC7\u90AE\u7BB1\u767B\u5F55\u6216\u627E\u56DE\u5BC6\u7801\uFF09" : "",
                onSettingsClick: openModal(MODALS.UPDATE_EMAIL),
                settingsLabel: data.email_verified ? "\u8BBE\u7F6E" : "\u9A8C\u8BC1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_component, {
                title: "\u5BC6\u7801",
                text: hasPassword ? "\u5DF2\u8BBE\u7F6E\uFF0C\u53EF\u901A\u8FC7\u8D26\u6237\u5BC6\u7801\u767B\u5F55" : "\u672A\u8BBE\u7F6E",
                onSettingsClick: openModal(hasPassword ? MODALS.UPDATE_PASSWORD : MODALS.SET_PASSWORD)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_component, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "\u7ED1\u5B9A\u7B2C\u4E09\u65B9\u8D26\u53F7"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Desc, {
                        children: "\u7ED1\u5B9A\u540E\u53EF\u901A\u8FC7\u7B2C\u4E09\u65B9\u5E94\u7528\u5FEB\u901F\u767B\u5F55\uFF0C\u5E76\u83B7\u5F97 20 \u79EF\u5206\u5956\u52B1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialAccounts, {
                        children: github ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Account, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(GithubIcon, {}),
                                github.login,
                                "\uFF08",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    onClick: unbind("github"),
                                    children: "\u89E3\u7ED1"
                                }),
                                "\uFF09"
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                            type: "text",
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(GithubIcon, {}),
                            onClick: bind("github"),
                            children: "\u7ED1\u5B9A GitHub"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdateEmailModal_component, Content_component_objectSpread({}, genModalProps(MODALS.UPDATE_EMAIL), {
                verified: data.email_verified
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdatePhoneModal_component, Content_component_objectSpread({}, genModalProps(MODALS.UPDATE_PHONE))),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SetPasswordModal_component, Content_component_objectSpread({}, genModalProps(MODALS.SET_PASSWORD), {
                onSuccess: reLogin
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdatePasswordModal_component, Content_component_objectSpread({}, genModalProps(MODALS.UPDATE_PASSWORD), {
                onSuccess: reLogin
            }))
        ]
    });
};
/* harmony default export */ var Content_component = (Content_component_Content);

;// CONCATENATED MODULE: ./src/pages/my/settings/content/index.js


// EXTERNAL MODULE: ./src/pages/my/layout/index.js + 5 modules
var layout = __webpack_require__(35703);
;// CONCATENATED MODULE: ./src/pages/my/settings/index.page.js






var PageContent = function(param) {
    var title = param.title;
    var ref = (0,react.useContext)(context/* AuthContext */.Vo), login = ref.login, isAnonymous = ref.isAnonymous;
    var meData = (0,react.useContext)(context/* MeContext */.io).meData;
    if (isAnonymous) {
        login();
        return null;
    }
    if (!meData) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLoader */.wY, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
        title: title,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content_component, {})
    });
};
var Page = function() {
    var title = "\u8D26\u53F7\u8BBE\u7F6E";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageContent, {
                title: title
            })
        ]
    });
};
/* harmony default export */ var index_page = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [228,9774,2888,179], function() { return __webpack_exec__(99924); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);